// src/components/AnimatedBlock.tsx
import { motion } from 'framer-motion';

const AnimatedBlock = ({ children }: { children: React.ReactNode }) => (
  <motion.div
    initial={{ opacity: 0, y: 0 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.3, ease: 'easeOut' }}
  >
    {children}
  </motion.div>
);

export default AnimatedBlock;
